import { DefaultMenuProvider } from './default/defaultMenuProvider';
import { IMENUPROVIDERSERVICE_TOKEN } from './interfaces/menuProvider';


export const DEFAULT_MENU_PROVIDER_ENTRY = { provide: IMENUPROVIDERSERVICE_TOKEN, useClass: DefaultMenuProvider, multi: false };